/*
 * Анкор-скрол колекцій/якорів — pure vanilla (без jQuery), self-contained IIFE.
 * Чому vanilla + async: залежність від jQuery (87KB) гейтила перший холодний клік —
 * хендлер реєструвався лише коли jQuery докочувався (~1с). Незалежний ~3KB-скрипт
 * (async) готовий одразу. Shopify best practice: native DOM APIs замість jQuery.
 *
 * На цих сторінках справжній скрол-контейнер — #app (overflow-x: clip → overflow-y auto),
 * тому НІ нативний smooth (scrollTo({behavior:'smooth'}) / scroll-behavior), НІ jQuery
 * .animate scrollTop не працюють — мовчить усе, крім instant window.scrollTo(0, y).
 * Тож плавність робимо власним rAF поверх instant scrollTo (на пристрої 60fps = плавно),
 * а фінальну позицію гарантуємо instant-доскролом (на випадок тротлінгу rAF у фоні).
 */
(function () {
  "use strict";

  // Безпечне резолвлення #hash → елемент. querySelector("#100-followers-2") кидає
  // "not a valid selector" (CSS-ID не може починатися з цифри), а getElementById —
  // приймає будь-який ID. Ловимо й декодування (напр. кириличні/екрановані хеші).
  function elByHash(hash) {
    if (!hash || hash.length < 2 || hash.charAt(0) !== "#") return null;
    var id = hash.slice(1);
    try { id = decodeURIComponent(id); } catch (e) { /* лишаємо як є */ }
    return document.getElementById(id);
  }

  function expandGrowthGridIfExists(callback) {
    var block = document.getElementById("growth-grid-block");
    if (!block) { if (callback) callback(); return; }

    var wasExpanded = block.classList.contains("is-expanded");
    block.classList.add("is-expanded");
    if (wasExpanded) { if (callback) callback(); return; }

    var called = false;
    function done() { if (called) return; called = true; if (callback) callback(); }
    block.addEventListener("transitionend", function handler(e) {
      if (e.target !== block) return;
      block.removeEventListener("transitionend", handler);
      done();
    });
    setTimeout(done, 400);
  }

  // Ціль: блок стає ПІД липкою шапкою (щоб іконка+заголовок секції не ховались).
  // Офсет = реальна висота шапки + запас → авто-адаптація десктоп/мобайл.
  function hashTargetY(hash) {
    var t = elByHash(hash);
    if (!t) return null;
    // Іконка секції (.tag-image) стирчить над контейнером .tag-products-grid (негативний
    // margin) — цілимось у ВЕРХ ІКОНКИ, інакше вона ховається під липку шапку.
    var icon = t.querySelector(".tag-image");
    var topEl = icon || t;
    var docTop = topEl.getBoundingClientRect().top + window.pageYOffset;
    var header = document.querySelector(".header");
    // Низ липкого стеку (шапка + банер над нею) відносно вьюпорта, не висота шапки.
    var stickyBottom = header ? Math.round(header.getBoundingClientRect().bottom) : 67;
    var offset = t.classList.contains("scroll-top") ? stickyBottom + 40 : stickyBottom + 20;
    return Math.max(0, docTop - offset);
  }

  function scrollToHashInstant(hash) {
    var y = hashTargetY(hash);
    if (y !== null) window.scrollTo(0, y);
  }

  var _scrollRAF = null;

  // Плавний скрол до блоку: одразу стартує (rAF), ціль перераховується щокадру
  // (слідує за блоком, якщо секції ще довантажуються), гарантований instant-доскрол.
  function scrollToHash(hash) {
    if (hashTargetY(hash) === null) return;
    if (_scrollRAF) { cancelAnimationFrame(_scrollRAF); _scrollRAF = null; }

    var startY = window.pageYOffset;
    var startT = null;
    var duration = 420;
    var done = false;

    function easeOutCubic(x) { return 1 - Math.pow(1 - x, 3); }
    function finish() {
      if (done) return;
      done = true;
      scrollToHashInstant(hash); // гарантія: точно долетіли до цілі
    }
    function step(ts) {
      if (startT === null) startT = ts;
      var p = Math.min((ts - startT) / duration, 1);
      var endY = hashTargetY(hash);
      if (endY === null) endY = startY;
      window.scrollTo(0, Math.round(startY + (endY - startY) * easeOutCubic(p)));
      if (p < 1) { _scrollRAF = requestAnimationFrame(step); }
      else { _scrollRAF = null; finish(); }
    }
    _scrollRAF = requestAnimationFrame(step);
    setTimeout(finish, duration + 140); // rAF затротлено (фон) → долітаємо instant-ом
  }

  // Колекційні сторінки ліниво довантажують секції ПІСЛЯ скролу, тож блок може зсунутись
  // у документі. Трекаємо ДОК-позицію цілі (стабільна під час скролу, змінюється лише при
  // reflow) і переасертимо, поки не стабілізується ~0.6с (макс 4с), зупиняючись на дії юзера.
  function reassertScroll(hash) {
    scrollToHash(hash);

    var stable = 0;
    var lastDocY = null;
    var userScrolled = false;
    var interval = null;
    var deadline = null;

    function cleanup() {
      if (interval) clearInterval(interval);
      if (deadline) clearTimeout(deadline);
      window.removeEventListener("wheel", onUser);
      window.removeEventListener("touchstart", onUser);
      window.removeEventListener("keydown", onUser);
    }
    function onUser() { userScrolled = true; cleanup(); }

    window.addEventListener("wheel", onUser, { passive: true });
    window.addEventListener("touchstart", onUser, { passive: true });
    window.addEventListener("keydown", onUser);

    interval = setInterval(function () {
      if (userScrolled) return cleanup();
      var d = hashTargetY(hash);
      if (d === null) return;
      d = Math.round(d);
      if (lastDocY !== null && Math.abs(d - lastDocY) < 2) {
        if (++stable >= 3) cleanup(); // ДОК-позиція стабільна → готово
      } else {
        stable = 0;
        // блок зсунувся (reflow) → миттєво підправляємо (не пере-анімовуємо, щоб не смикати)
        if (lastDocY !== null) scrollToHashInstant(hash);
      }
      lastDocY = d;
    }, 200);

    deadline = setTimeout(cleanup, 4000);
  }

  function autoScrollToCurrentHash() {
    var hash = window.location.hash;
    if (!elByHash(hash)) return;
    expandGrowthGridIfExists(function () { reassertScroll(hash); });
  }

  // Загальні якорі на цій же сторінці (меню тощо), крім data-local-scroll і no-scrolling.
  // ПІЛСИ колекції (.collection-tag) обробляє критичний ІНЛАЙН-хендлер у <head> (theme.liquid) —
  // щоб перший клік працював миттєво, не чекаючи завантаження цього файлу. Тут їх НЕ дублюємо.
  document.addEventListener("click", function (e) {
    var a = e.target.closest("a[href]");
    if (!a) return;
    if (a.getAttribute("data-local-scroll") || !a.hash || a.classList.contains("no-scrolling") || a.classList.contains("collection-tag")) return;
    if (a.pathname === location.pathname && a.hostname === location.hostname) {
      if (!elByHash(a.hash)) return;
      e.preventDefault();
      expandGrowthGridIfExists(function () { scrollToHash(a.hash); });
    }
  });

  // Початковий скрол за хешем — після готовності DOM (async може виконатись раніше parse).
  function onReady() { autoScrollToCurrentHash(); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
  window.addEventListener("load", autoScrollToCurrentHash);     // докотились картинки
  window.addEventListener("hashchange", autoScrollToCurrentHash); // клік на тій самій сторінці
})();
